import React from 'react'

interface IProps {
  onLeave: () => void
  onCancel: () => void
  onSave: () => Promise<void> | void
  saving?: boolean
}

export const UnsavedChangesModal: React.FC<IProps> = ({ onLeave, onCancel, onSave, saving = false }) => {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(30, 30, 60, 0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 16,
          padding: '40px 32px 32px',
          maxWidth: 420,
          width: '90%',
          textAlign: 'center',
          position: 'relative',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        }}
      >
        <button
          type='button'
          onClick={onCancel}
          style={{
            position: 'absolute',
            top: 14,
            right: 16,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1.4rem',
            color: '#9ca3af',
            lineHeight: 1,
          }}
        >
          ×
        </button>

        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: '#e8f4fb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
          }}
        >
          <i className='bi bi-exclamation-triangle' style={{ fontSize: '1.4rem', color: '#007BC3' }} />
        </div>

        <h5 className='fw-bold mb-3' style={{ color: '#111827', fontSize: 18 }}>
          Tienes cambios sin guardar
        </h5>
        <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 28, lineHeight: 1.6 }}>
          Si sales ahora, perderás los cambios realizados.
          <br />
          ¿Deseas guardarlos antes de continuar?
        </p>

        <div className='d-flex gap-3 justify-content-center'>
          <button
            type='button'
            onClick={onLeave}
            style={{
              border: '2px solid #007BC3',
              background: 'transparent',
              color: '#007BC3',
              borderRadius: 50,
              padding: '10px 22px',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: 14,
              minWidth: 140,
            }}
          >
            Salir sin guardar
          </button>
          <button
            type='button'
            onClick={() => onSave()}
            disabled={saving}
            style={{
              border: 'none',
              background: '#007BC3',
              color: '#fff',
              borderRadius: 50,
              padding: '10px 22px',
              fontWeight: 600,
              cursor: saving ? 'not-allowed' : 'pointer',
              fontSize: 14,
              opacity: saving ? 0.7 : 1,
              minWidth: 140,
            }}
          >
            {saving ? 'Guardando...' : 'Guardar y continuar'}
          </button>
        </div>
      </div>
    </div>
  )
}
